/**
 * Multi-tenancy utility functions
 */

/**
 * Extract the tenant subdomain from the current URL.
 * For *.purplehq.ch, returns the subdomain portion.
 * Returns null for localhost, app.purplehq.ch, or direct IP access.
 */
export const getTenantSubdomain = () => {
  const hostname = window.location.hostname;

  // No tenant on localhost or IP addresses
  if (hostname === 'localhost' || hostname === '127.0.0.1' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    // In development, check for a tenant override in localStorage
    return localStorage.getItem('dev_tenant_subdomain') || null;
  }

  const baseDomain = process.env.REACT_APP_BASE_DOMAIN || 'purplehq.ch';
  if (!hostname.endsWith(`.${baseDomain}`)) {
    return null;
  }

  const subdomain = hostname.replace(`.${baseDomain}`, '');

  // 'app' and 'www' are reserved for the super admin portal
  if (subdomain === 'app' || subdomain === 'www' || !subdomain) {
    return null;
  }

  return subdomain;
};

/**
 * Check if the current portal is the super admin portal.
 * True on app.purplehq.ch, localhost, or direct IP access.
 */
export const isSuperAdminPortal = () => {
  return getTenantSubdomain() === null;
};

/**
 * Check if we're in a tenant context.
 */
export const isTenantPortal = () => {
  return getTenantSubdomain() !== null;
};

/**
 * Set a development tenant subdomain override (for localhost testing).
 */
export const setDevTenantSubdomain = (subdomain) => {
  if (subdomain) {
    localStorage.setItem('dev_tenant_subdomain', subdomain);
  } else {
    localStorage.removeItem('dev_tenant_subdomain');
  }
};
